import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';
import { inboxEntriesKeys } from '../../../Sidebar/api/getInboxEntries';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type DeleteFileDTO = {
  fileId: number;
  trash: boolean;
};

export const deleteFile = ({ fileId, trash }: DeleteFileDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { trash },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useDeleteFileOptions = {
  projectId: string;
  sourceFileId: number;
  trash: boolean;
  config?: MutationConfig<typeof deleteFile>;
};

export const useMarkDeleteFile = ({
  projectId,
  sourceFileId,
  trash,
  config,
}: useDeleteFileOptions) => {
  return useMutation({
    onSuccess: (data) => {
      // queryClient.invalidateQueries([...inboxEntriesKeys.lists({ projectId })]);
      if (data.status === false) {
        return;
      }

      queryClient.setQueryData(
        [...fileDetailsKeys.detail({ fileId: sourceFileId })],
        (prev: any) => {
          return {
            ...prev,
            data: {
              ...prev.data,
              trash,
            },
          };
        }
      );

      queryClient.invalidateQueries([...activityLogsKeys.list(sourceFileId)]);
    },
    ...config,
    mutationFn: deleteFile,
  });
};
